var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"percent-bar",style:(_vm.style)},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"percent-bar__bg"},[_c('div',{staticClass:"percent-bar__fg"})])
}]

export { render, staticRenderFns }